<template>
  <div class="order-detail-page full-height display-col">
    <full-con :canReturn='canReturn'>
      <div slot="editBreadcrumb">
        <editBreadcrumb :pageTitle="pageTitle"></editBreadcrumb>
      </div>
      <div slot="full">
        <div class="order-detail-container full-height flex1">
          <el-form>
            <div class="tabel-container">
              <div class="table-title">订单信息</div>
              <el-row class="table-content">
                <el-col :span="8" class="content">
                  <el-row v-if="false">
                    <el-col :span="10">id.：</el-col>
                    <el-col :span="14">{{problemInfo.id}}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">订单编号：</el-col>
                    <el-col :span="14">{{problemInfo.orderNo}}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">创建时间：</el-col>
                    <el-col :span="14">{{problemInfo.createTime | dateFormatToSecond}}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">处理日期：</el-col>
                    <el-col :span="14">{{problemInfo.handleTime | dateFormatToSecond}}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">发回运单号：</el-col>
                    <el-col :span="14">{{problemInfo.returnWaybillNo}}</el-col>
                  </el-row>

                </el-col>
                <el-col :span="8" class="content">
                  <el-row>
                    <el-col :span="10">用户ID：</el-col>
                    <el-col :span="14">{{problemInfo.userName}}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">数量：</el-col>
                    <el-col :span="14">{{problemInfo.count}}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">退货运费：</el-col>
                    <el-col :span="14">{{problemInfo.returnFee}}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">重发运单号：</el-col>
                    <el-col :span="14">{{problemInfo.waybillNumber}}</el-col>
                  </el-row>
                </el-col>
                <el-col :span="8" class="content">
                  <el-row>
                    <el-col :span="10">订单状态：</el-col>
                    <el-col :span="14">{{problemInfo.handleState | problemStatusFilter}}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">不良数量：</el-col>
                    <el-col :span="14">{{problemInfo.badCount}}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10">异常处理费：</el-col>
                    <el-col :span="14">{{problemInfo.problemHandlingFee}}</el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="10"></el-col>
                    <el-col :span="14"></el-col>
                  </el-row>
                </el-col>
                <el-col :span="24" class="content" >
                  <el-row>
                    <el-col :span="4" style="width: 14%">不良描述：</el-col>
                    <el-col :span="20">{{problemInfo.badDescription}}</el-col>
                  </el-row>
                </el-col>
                <el-col :span="24" class="content">
                  <el-row>
                    <el-col :span="4"  style="width: 14%">退货地址</el-col>
                    <el-col :span="20">{{problemInfo.returnAddress}}</el-col>
                  </el-row>
                </el-col>
                <el-col :span="24" class="content">
                  <el-row>
                    <el-col :span="4"  style="width: 14%">处理说明：</el-col>
                    <el-col :span="20">{{problemInfo.handleDescription}}</el-col>
                  </el-row>
                </el-col>

                <div style=" overflow:hidden; width: 100%; margin-top: 200px;padding-left: 170px" class="autopl">
                  <el-col :span="8" class="content" style="overflow: hidden">
                    <div v-if="editImgUrl1=='' && problemInfo.problemUrl1 != null" class="new-img" style="float:left;position: relative">
                      <img :src="problemInfo.problemUrl1" alt="" style="width: 150px;height: 150px;">
                      <i v-if="problemInfo.problemUrl1" @click="deletePicture(1)" class="delete-img-btn el-icon-delete"></i>
                      <div class="new-img-shadow"></div>
                    </div>
                    <div style="float:left;margin-left: 1px">
                      <el-upload class="editor-slide-upload"
                                 action="https://zkvip-oss.oss-cn-hongkong.aliyuncs.com"
                                 :multiple="true"
                                 :data="imgDataObj"
                                 :file-list="imgFileList"
                                 :show-file-list="true"
                                 list-type="picture-card"
                                 :on-remove="handleImgRemove"
                                 :on-success="handleImgSuccess"
                                 :before-upload="beforeImgUpload"
                                 :limit="1">
                        <el-button size="small" type="primary">点击上传</el-button>
                      </el-upload>
                    </div>
                  </el-col>
                  <el-col :span="8" class="content" style="overflow: hidden">
                    <div v-if="editImgUrl2=='' && problemInfo.problemUrl2 != null" class="new-img" style="float:left;position: relative">
                      <img :src="problemInfo.problemUrl2" alt="" style="width: 150px;height: 150px;">
                      <i v-if="problemInfo.problemUrl2" @click="deletePicture(2)" class="delete-img-btn el-icon-delete"></i>
                      <!--<el-button v-if="problemInfo.problemUrl2" circle icon="el-icon-delete" @click="deletePicture(2)"></el-button>-->
                      <div class="new-img-shadow"></div>
                    </div>

                    <div style="float:left;margin-left: 1px">
                      <el-upload class="editor-slide-upload"
                                 action="https://zkvip-oss.oss-cn-hongkong.aliyuncs.com"
                                 :multiple="true"
                                 :data="imgSecondDataObj"
                                 :file-list="imgSecondFileList"
                                 :show-file-list="true"
                                 list-type="picture-card"
                                 :on-remove="handleImgSecondRemove"
                                 :on-success="handleImgSecondSuccess"
                                 :before-upload="beforeImgSecondUpload"
                                 :limit="1">
                        <el-button size="small" type="primary">点击上传</el-button>
                      </el-upload>
                    </div>
                    <!--<img :src="problemInfo.problemUrl1" alt="" style="width: 150px;height: 150px;">-->
                  </el-col>
                  <el-col :span="8" class="content" style="overflow: hidden">
                    <div v-if="editImgUrl3=='' && problemInfo.problemUrl3 != null" class="new-img" style="float:left;position: relative">
                      <img :src="problemInfo.problemUrl3" alt="" style="width: 150px;height: 150px;">
                      <i v-if="problemInfo.problemUrl3" @click="deletePicture(3)" class="delete-img-btn el-icon-delete"></i>
                      <!--<el-button v-if="problemInfo.problemUrl3" circle icon="el-icon-delete" @click="deletePicture(3)"></el-button>-->
                      <div class="new-img-shadow"></div>
                    </div>

                    <div style="float:left;margin-left: 1px">
                      <el-upload class="editor-slide-upload"
                                 action="https://zkvip-oss.oss-cn-hongkong.aliyuncs.com"
                                 :multiple="true"
                                 :data="imgThirdDataObj"
                                 :file-list="imgThirdFileList"
                                 :show-file-list="true"
                                 list-type="picture-card"
                                 :on-remove="handleImgThirdRemove"
                                 :on-success="handleImgThirdSuccess"
                                 :before-upload="beforeImgThirdUpload"
                                 :limit="1">
                        <el-button size="small" type="primary">点击上传</el-button>
                      </el-upload>
                    </div>
                    <!--<img :src="problemInfo.problemUrl3" alt="" style="width: 150px;height: 150px;">-->
                  </el-col>
                </div>
              </el-row>
              <div slot="footer" style="padding-left: 50%;margin-top: 22%">
                <el-button class="form-btn btn-blue" @click="pictureSave">确 定</el-button>
                <!--<el-button @click="clearReplyForm">取 消</el-button>-->
              </div>
            </div>
          </el-form>
        </div>
      </div>
    </full-con>
  </div>
</template>

<script>
import editBreadcrumb from '../../views/layout/components/editBreadCrumb'

import Oss from '../../assets/js/oss.js';
export default {
  components:{editBreadcrumb},

  data() {
      return {
        canReturn:'1',
        pageTitle:'订单详情',
          listObj:[],
          listSecondObj:[],
          listThirdObj:[],
          imgDataObj: {
              policy: '',
              signature: '',
              key: '',
              ossaccessKeyId: '',
              dir: '',
              host: '',
              timeStamp:'',
              flag1:0
          },
          imgSecondDataObj: {
              policy: '',
              signature: '',
              key: '',
              ossaccessKeyId: '',
              dir: '',
              host: '',
              timeStamp:'',
              flag1:0
          },
          imgThirdDataObj: {
              policy: '',
              signature: '',
              key: '',
              ossaccessKeyId: '',
              dir: '',
              host: '',
              timeStamp:'',
              flag1:0
          },

        id:'',
        problemInfo:{
            problemUrl1:'',
            problemUrl2:'',
            problemUrl3:'',
        },
          editImgUrl1:'',
          editImgUrl2:'',
          editImgUrl3:'',
          imgFileList:[],
          imgSecondFileList:[],
          imgThirdFileList:[],
          flag:false,
          flagSecond:false,
          flagThird:false
      }
    },
    methods: {
        deletePicture(flag){
            if(flag == 1){
                this.editImgUrl1 = null;
                this.imgDataObj = {};
                this.flag = true;
            }else if(flag == 2){
                this.editImgUrl2 = null;
                this.imgSecondDataObj = {};
                this.flagSecond = true;
            }else if(flag == 3){
                this.editImgUrl3 = null;
                this.imgThirdDataObj = {};
                this.flagThird = true;
            }

        },
        handleImgSubmit() {
            var _this = this;
            const arr = Object.keys(_this.listObj).map(v => _this.listObj[v]);
            if (!Oss.checkAllSuccess(_this.listObj)) {
                _this.$message('请等待所有图片上传成功 或 出现了网络问题，请刷新页面重新上传！')
                return
            }
            else{
                if(arr.length>3){
                    _this.$message.error('最多可上传3张图片');
                }
                else{
                    // if(arr.length>0){
                    // this.addFormInfo.tableData[this.curRow].pictureUrl = arr[0].url + '?x-oss-process=image/resize,m_fill,h_50,w_50'
                    // }
                    _this.imgFileList = _this.imgFileList.concat(arr);
                    var urlArr = [];
                    _this.imgFileList.forEach(el=>{
                        urlArr.push(el.url);
                    })
                    _this.problemInfo.problemUrl1 = urlArr.toString();
                    _this.$emit('successCBK', arr);
                    _this.listObj = {};
                }
            }
        },
        handleImgSecondSubmit() {
            var _this = this;
            const arr = Object.keys(_this.listSecondObj).map(v => _this.listSecondObj[v]);
            if (!Oss.checkAllSuccess(_this.listSecondObj)) {
                _this.$message('请等待所有图片上传成功 或 出现了网络问题，请刷新页面重新上传！')
                return
            }
            else{
                if(arr.length>3){
                    _this.$message.error('最多可上传3张图片');
                }
                else{
                    // if(arr.length>0){
                    // this.addFormInfo.tableData[this.curRow].pictureUrl = arr[0].url + '?x-oss-process=image/resize,m_fill,h_50,w_50'
                    // }
                    _this.imgSecondFileList = _this.imgSecondFileList.concat(arr);
                    var urlArr = [];
                    _this.imgSecondFileList.forEach(el=>{
                        urlArr.push(el.url);
                    })
                    _this.problemInfo.problemUrl2 = urlArr.toString();
                    _this.$emit('successCBK', arr);
                    _this.listSecondObj = {};
                }
            }
        },
        handleImgThirdSubmit() {
            var _this = this;
            const arr = Object.keys(_this.listThirdObj).map(v => _this.listThirdObj[v]);
            if (!Oss.checkAllSuccess(_this.listThirdObj)) {
                _this.$message('请等待所有图片上传成功 或 出现了网络问题，请刷新页面重新上传！')
                return
            }
            else{
                if(arr.length>3){
                    _this.$message.error('最多可上传3张图片');
                }
                else{
                    // if(arr.length>0){
                    // this.addFormInfo.tableData[this.curRow].pictureUrl = arr[0].url + '?x-oss-process=image/resize,m_fill,h_50,w_50'
                    // }
                    _this.imgThirdFileList = _this.imgThirdFileList.concat(arr);
                    var urlArr = [];
                    _this.imgThirdFileList.forEach(el=>{
                        urlArr.push(el.url);
                    })
                    _this.problemInfo.problemUrl3 = urlArr.toString();
                    _this.$emit('successCBK', arr);
                    _this.listThirdObj = {};
                }
            }
        },
        handleImgRemove(file) {
            this.editImgUrl1 = null;
            Oss.imgRemove(file,this.listObj);
            this.flag = true;
        },
        handleImgSuccess(response, file) {
            Oss.imgSuccess(file,this.listObj,this.imgDataObj);
        },
        beforeImgUpload(file) {
            const _self = this;
            const fileName = file.uid;
            this.listObj[fileName] = {};
            return new Promise((resolve, reject) => {
                _self.$http.get('aliyun/oss/policy').then(response => {
                    var num = "";   //定义编号
                    for (var i = 0; i < 4; i++) //4位随机数，用以加在时间戳后面。
                    {
                        num += Math.floor(Math.random() * 10);
                    }
                    num = new Date().getTime() + num;  //时间戳，用来生成编号。
                    _self.imgDataObj.policy = response.data.data.policy;
                    _self.imgDataObj.signature = response.data.data.signature;
                    _self.imgDataObj.ossaccessKeyId = response.data.data.accessKeyId;
                    _self.imgDataObj.key = response.data.data.dir +'/bad/' + num +'${filename}';
                    _self.imgDataObj.dir = response.data.data.dir +'/bad';
                    _self.imgDataObj.host = response.data.data.host;
                    _self.imgDataObj.timeStamp = num;
                    Oss.imgCompress(file,this.listObj,resolve,reject);
                    _self.editImgUrl1 =  _self.imgDataObj.host+ '/' + _self.imgDataObj.dir + '/' + _self.imgDataObj.timeStamp + file.name;
                    // _self.editImgUrl2 =  _self.imgDataObj.host+ '/' + _self.imgDataObj.dir + '/' + _self.imgDataObj.timeStamp + file.name;
                    // _self.editImgUrl3 =  _self.imgDataObj.host+ '/' + _self.imgDataObj.dir + '/' + _self.imgDataObj.timeStamp + file.name;
                }).catch(err => {
                    reject(false)
                })
            })
        },
        handleImgSecondRemove(file) {
            this.editImgUrl2 = null;
            Oss.imgRemove(file,this.listSecondObj);
            this.flagSecond = true;
        },
        handleImgSecondSuccess(response, file) {
            Oss.imgSuccess(file,this.listSecondObj,this.imgSecondDataObj);
        },
        beforeImgSecondUpload(file) {
            const _self = this;
            const fileName = file.uid;
            this.listSecondObj[fileName] = {};
            return new Promise((resolve, reject) => {
                _self.$http.get('aliyun/oss/policy').then(response => {
                    var num = "";   //定义编号
                    for (var i = 0; i < 4; i++) //4位随机数，用以加在时间戳后面。
                    {
                        num += Math.floor(Math.random() * 10);
                    }
                    num = new Date().getTime() + num;  //时间戳，用来生成编号。
                    _self.imgSecondDataObj.policy = response.data.data.policy;
                    _self.imgSecondDataObj.signature = response.data.data.signature;
                    _self.imgSecondDataObj.ossaccessKeyId = response.data.data.accessKeyId;
                    _self.imgSecondDataObj.key = response.data.data.dir +'/problem/' + num +'${filename}';
                    _self.imgSecondDataObj.dir = response.data.data.dir +'/problem';
                    _self.imgSecondDataObj.host = response.data.data.host;
                    _self.imgSecondDataObj.timeStamp = num;
                    Oss.imgCompress(file,this.listSecondObj,resolve,reject);
                    // _self.editImgUrl1 =  _self.imgSecondDataObj.host+ '/' + _self.imgSecondDataObj.dir + '/' + _self.imgSecondDataObj.timeStamp + file.name;
                    _self.editImgUrl2 =  _self.imgSecondDataObj.host+ '/' + _self.imgSecondDataObj.dir + '/' + _self.imgSecondDataObj.timeStamp + file.name;
                    // _self.editImgUrl3 =  _self.imgSecondDataObj.host+ '/' + _self.imgSecondDataObj.dir + '/' + _self.imgSecondDataObj.timeStamp + file.name;
                }).catch(err => {
                    reject(false)
                })
            })
        },
        handleImgThirdRemove(file) {
            this.editImgUrl3 = null;
            Oss.imgRemove(file,this.listThirdObj);
            this.flagThird = true;
        },
        handleImgThirdSuccess(response, file) {
            Oss.imgSuccess(file,this.listThirdObj,this.imgThirdDataObj);
        },
        beforeImgThirdUpload(file) {
            const _self = this;
            const fileName = file.uid;
            this.listThirdObj[fileName] = {};
            return new Promise((resolve, reject) => {
                _self.$http.get('aliyun/oss/policy').then(response => {
                    var num = "";   //定义编号
                    for (var i = 0; i < 4; i++) //4位随机数，用以加在时间戳后面。
                    {
                        num += Math.floor(Math.random() * 10);
                    }
                    num = new Date().getTime() + num;  //时间戳，用来生成编号。
                    _self.imgThirdDataObj.policy = response.data.data.policy;
                    _self.imgThirdDataObj.signature = response.data.data.signature;
                    _self.imgThirdDataObj.ossaccessKeyId = response.data.data.accessKeyId;
                    _self.imgThirdDataObj.key = response.data.data.dir +'/problem/' + num +'${filename}';
                    _self.imgThirdDataObj.dir = response.data.data.dir +'/problem';
                    _self.imgThirdDataObj.host = response.data.data.host;
                    _self.imgThirdDataObj.timeStamp = num;
                    Oss.imgCompress(file,this.listThirdObj,resolve,reject);
                    // _self.editImgUrl1 =  _self.imgThirdDataObj.host+ '/' + _self.imgThirdDataObj.dir + '/' + _self.imgThirdDataObj.timeStamp + file.name;
                    // _self.editImgUrl2 =  _self.imgThirdDataObj.host+ '/' + _self.imgThirdDataObj.dir + '/' + _self.imgThirdDataObj.timeStamp + file.name;
                    _self.editImgUrl3 =  _self.imgThirdDataObj.host+ '/' + _self.imgThirdDataObj.dir + '/' + _self.imgThirdDataObj.timeStamp + file.name;
                }).catch(err => {
                    reject(false)
                })
            })
        },
        pictureSave(){    //确定按钮
            this.addReply(this.problemInfo.id);
        },
        async addReply(id){
            var my=this;
            console.log(this.editImgUrl1);
            if(this.flag){
                my.problemInfo.problemUrl1 = this.editImgUrl1;
            }else if(my.problemInfo.problemUrl1 != this.editImgUrl1 && this.editImgUrl1 != ''){
                my.problemInfo.problemUrl1 = this.editImgUrl1;
            }
            if(this.flagSecond){
                my.problemInfo.problemUrl2 = this.editImgUrl2;
            }else if(this.editImgUrl2 != my.problemInfo.problemUrl2 && this.editImgUrl2 != ''){
                my.problemInfo.problemUrl2 = this.editImgUrl2;
            }
            if(this.flagThird){
                my.problemInfo.problemUrl3 = this.editImgUrl3;
            }else if(this.editImgUrl3 != my.problemInfo.problemUrl3 && this.editImgUrl3 != ''){
                my.problemInfo.problemUrl3 = this.editImgUrl3;
            }
            var url = 'problem/updateProblem';
            const {data:res} = await my.$http.post(url,my.problemInfo);
            if(res.code == 200){
                my.$message({
                    type:'success',
                    message:res.message
                }),
                this.flag = false;
                my.getOrderDetail();
            } else{
                my.$message({
                    type:'warning',
                    message:res.message
                })
            }
        },
      async getOrderDetail(){
        const {data:res} = await this.$http.get('problem/'+this.id);
        this.problemInfo = res.data;
      }
    },
    created(){
      this.id = this.$route.query.id;
      this.getOrderDetail();
    },
}
</script>

<style lang="less" scoped>
@media screen and (max-width: 1356px) {
  .autopl{
    padding-left: 120px!important;
  }

}
  .order-detail-container{
    background: #fff;
    padding: 20px;
  }
  ul,li{
    list-style: none;
  }
  .table-title{
    padding: 5px 0;
    text-align: center;
    background: #F1F2F6;
  }
  .table-content{
     border-right: 1px solid #E5E9F8;
  }
  .table-content .content .el-col{
    height: 35px;
    line-height: 30px;
    padding: 0 2px;
    border-left: 1px solid #E5E9F8;
    border-bottom: 1px solid #E5E9F8;
    text-align: center;
    // white-space:nowrap;
    // text-overflow:ellipsis;
    overflow:auto;
  }
  .el-form-item{
    margin-bottom: 0 !important;
  }
 /deep/.el-form-item__content{
    line-height: 30px !important;
  }
  // .table-content .content{
  //   padding-bottom: 10px;
  // }
      .new-img-shadow{
          width:150px;
          height:150px;
          display:none;
          position:absolute;
          left:0;
          top:0;
          background:rgba(0,0,0,0.5);

      }
    .new-img:hover .new-img-shadow{
        display:block;
    }
    .delete-img-btn{
        width:20px;
        height:20px;
        color:#fff;
        position: absolute;
        left: 45%;
        top: 45%;
        z-index:9999;
        display: none;

    }
    .new-img:hover .delete-img-btn{
        display: block;
    }

</style>

